import React, { useRef, useState } from 'react';
import { useAppSelector } from 'careand-redux/store';
import { downloadBlob } from 'services/FileDownloadUtils';
import { api } from 'careand-redux/api/ApiThunks';
import ListBadge from 'components/Common/ListBadge';
import CalendarUtils from 'services/CalendarUtils';
import ProgressMessage from 'components/Utils/ProgressMessage';
import ReceiptModal from 'components/Payments/ReceiptList/ReceiptModal';

const dateFormat = 'DD/MM/YYYY';

const ReceiptBadge = ({ receipt, patient, onClick, children, buttons }) => {
  const { description, amount_refunded, date } = receipt;

  const linkRef = useRef();

  const role = useAppSelector((state) => state.authentication.role);
  const isPatient = role === 'patient';

  const [loading, setLoading] = useState(false);
  const [receiptModal, setReceiptModal] = useState(false);

  async function getReceiptPdfWrapper() {
    if (onClick) return onClick(receipt);
    if (!isPatient) return setReceiptModal(true);
    setLoading(true);

    await downloadBlob(
      api.Invoices.getReceiptPdf,
      { patientId: patient?.id, receiptId: receipt.id },
      { filename: `${description}.pdf`, timeout: 20_000 },
    );
    setLoading(false);
  }

  return (
    <>
      <ListBadge
        onClick={getReceiptPdfWrapper}
        disabled={loading}
        className="receipt-badge"
        title={description}
        firstLine={
          <>
            {CalendarUtils.format(date, dateFormat)} - {'$' + receipt.amount / 100.0}
            <ProgressMessage show={loading} size={20} />
          </>
        }
        alert={amount_refunded && !loading ? `$${amount_refunded / 100} Refunded` : undefined}
      >
        {children}
      </ListBadge>
      <ReceiptModal
        patient={patient}
        receipt={receipt}
        onClose={() => setReceiptModal(false)}
        open={receiptModal}
        buttons={buttons}
      />
      <a href="careand.ca" style={{ display: 'none' }} ref={linkRef}>
        Download
      </a>
    </>
  );
};

export default ReceiptBadge;
